/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Icon from "../Icon";

const ForwardSolidV6 = (props) => (
  <Icon {...props} name="Forward Solid V6">
    <path d="M1.641 13.769 7 9.303V6.697L1.641 2.232C.996 1.697 0 2.146 0 3.001v9.997c0 .855.996 1.305 1.641.771zm8 0 6-4.972a1.006 1.006 0 0 0 0-1.539l-6-4.972C8.996 1.751 8 2.2 8 3.055v9.997c0 .801.997 1.251 1.641.716z" />
  </Icon>
);

export default ForwardSolidV6;
